import React from 'react';
import { siteContent } from '../data/mock';
import { Button } from './ui/button';

// GA4 event tracking helper
const trackEvent = (eventName, eventParams = {}) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, eventParams);
  }
};

const Hero = ({ onRequestDemo }) => {
  const { hero } = siteContent;

  const handleRequestDemo = () => {
    // Track button click in GA4
    trackEvent('cta_click', {
      button_text: 'Request a demo',
      button_location: 'hero_section'
    });
    
    // Call the scroll handler
    onRequestDemo();
  };

  return (
    <section className="pt-32 pb-16">
      <div className="mx-auto max-w-6xl px-6">
        <div className="max-w-3xl">
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-medium text-neutral-900 leading-tight mb-6">
          {hero.headline}
        </h1>
        <p className="text-xl md:text-2xl text-neutral-600 leading-relaxed mb-4">
          {hero.subheadline}
        </p>
        <p className="text-base text-neutral-500 mb-10">
          {hero.context}
        </p>
        <Button 
          onClick={handleRequestDemo}
          className="bg-neutral-900 text-white hover:bg-neutral-800 px-8 py-6 text-base rounded-md"
        >
          {hero.cta}
        </Button>
        </div>
      </div>
    </section>
  );
};

export default Hero;
